/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";
import MasterDataCropResponse from "./MasterDataCropResponse";
import CropLinkCoverage from "./CropLinkCoverage";

const urls = {
    options(): string {
        return "/masterdatacrop/options";
    },
    coverage(): string {
        return "/masterdatacrop/coverage";
    }
}

export default {
    urls,
    options(): Promise<MasterDataCropResponse[]> {
        return contentOnly(Axios.get("/masterdatacrop/options", defaultConfig));
    },
    coverage(): Promise<CropLinkCoverage> {
        return contentOnly(Axios.get("/masterdatacrop/coverage", defaultConfig));
    }
}
